import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
var SET_SHARED_ENV = 'SET_SHARED_ENV';
export default SET_SHARED_ENV;